(function (root) {
    function createMissingJquery() {
        var chain;
        var chainNoop = function () {
            return chain;
        };
        var ajaxNoop = function () {
            return {
                done: chainNoop,
                fail: chainNoop,
                always: chainNoop,
                then: chainNoop,
            };
        };
        var fn = {jquery: '0.0.0'};

        chain = typeof Proxy !== 'undefined'
            ? new Proxy({length: 0}, {
                get: function (target, prop) {
                    if (prop in target) {
                        return target[prop];
                    }
                    if (prop in fn) {
                        return fn[prop];
                    }
                    return chainNoop;
                },
            })
            : fn;

        if (chain === fn) {
            fn.length = 0;
            fn.addClass = chainNoop;
            fn.removeClass = chainNoop;
            fn.on = chainNoop;
            fn.off = chainNoop;
            fn.ready = chainNoop;
            fn.each = chainNoop;
        }

        var missingJquery = function () {
            return chain;
        };

        missingJquery.fn = fn;
        missingJquery.support = {};
        missingJquery.ajax = ajaxNoop;
        missingJquery.ajaxPrefilter = chainNoop;
        missingJquery.get = ajaxNoop;
        missingJquery.getJSON = ajaxNoop;
        missingJquery.post = ajaxNoop;
        missingJquery.proxy = function (callback, context) {
            return typeof callback === 'function'
                ? function () {
                    return callback.apply(context || this, arguments);
                }
                : chainNoop;
        };
        missingJquery.each = function (items, callback) {
            if (!items || typeof callback !== 'function') {
                return items;
            }
            for (var key in items) {
                if (Object.prototype.hasOwnProperty.call(items, key)) {
                    callback.call(items[key], key, items[key]);
                }
            }
            return items;
        };
        missingJquery.extend = function (target) {
            target = target || {};
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i] || {};
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        };
        missingJquery.inArray = function (item, items) {
            return items && typeof items.indexOf === 'function' ? items.indexOf(item) : -1;
        };
        missingJquery.isFunction = function (value) {
            return typeof value === 'function';
        };
        missingJquery.trim = function (value) {
            return value == null ? '' : String(value).trim();
        };
        missingJquery.parseJSON = JSON.parse;
        missingJquery.widget = function (name, definition) {
            var parts = String(name || '').split('.');
            var namespace = parts.length > 1 ? parts[0] : null;
            var widgetName = parts.pop();
            if (widgetName) {
                if (namespace) {
                    missingJquery[namespace] = missingJquery[namespace] || {};
                    missingJquery[namespace][widgetName] = function () {};
                    missingJquery[namespace][widgetName].prototype = definition || {};
                }
                fn[widgetName] = chainNoop;
            }
        };

        return missingJquery;
    }

    var jquery = root && (root.jQuery || root.$);

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = jquery && jquery.fn ? jquery : createMissingJquery();
    } else if (root) {
        if (!jquery || !jquery.fn) {
            jquery = createMissingJquery();
        }
        root.jQuery = jquery;
        root.$ = jquery;
    }
}(typeof window !== 'undefined' ? window : this));
